import { useDispatch } from "react-redux";
import { Action } from "redux";

type UpdateActionPayload = {
  [key: string]: any;
};

type UpdateAction = (payload: UpdateActionPayload) => Action<string>;

const useFormUpdate = (
  dispatchAction: UpdateAction,
  globalCallback?: Function
) => {
  const dispatch = useDispatch();

  const handleInputChange =
    (fieldName: string, localCallback?: Function) => (e: any) => {
      const value = e.target.value;

      dispatch(dispatchAction({ [fieldName]: value }));

      // Gọi callback nếu có
      localCallback?.({ fieldName, value });
      globalCallback?.({ fieldName, value });
    };

  const handleCheckBoxChange =
    (fieldName: string, localCallback?: Function) => (e: any) => {
      const value = e.target.checked;

      dispatch(dispatchAction({ [fieldName]: value }));

      // Gọi callback nếu có
      localCallback?.({ fieldName, value });
      globalCallback?.({ fieldName, value });
    };

  const handleDatePickerChange =
    (fieldName: string, localCallback?: Function) => (e: any) => {
      // const value = moment(e).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      // dispatch(dispatchAction({ [fieldName]: value }));
      const value = e;
      dispatch(dispatchAction({ [fieldName]: value }));

      // Gọi callback nếu có
      localCallback?.({ fieldName, value });
      globalCallback?.({ fieldName, value });
    };

  const handleSelectChange =
    (fieldName: string, localCallback?: Function) => (e: any, child?: any) => {
      const value = e;
      dispatch(dispatchAction({ [fieldName]: value }));

      // Gọi callback nếu có
      localCallback?.({ fieldName, value });
      globalCallback?.({ fieldName, value });
    };

  const handleFileChange =
    (fieldName: string, localCallback?: Function) => (e: any) => {
      const value = e;
      dispatch(dispatchAction({ [fieldName]: value }));

      // Gọi callback nếu có
      localCallback?.({ fieldName, value });
      globalCallback?.({ fieldName, value });
    };

  return {
    handleFileChange,
    handleInputChange,
    handleCheckBoxChange,
    handleDatePickerChange,
    handleSelectChange,
  };
};

export default useFormUpdate;
